module.exports = __webpack_public_path__ + "static/media/ForwardPlay.67ce3f75.svg";